export default [
	{  // 【关于】-【Banner】
		path: 'website/about/banner',
		name: 'm_about_banner',
		meta: {
			title: '知识专区Banner'
		},
		component: () => import('@/pages/website/about/about_banner')
	},
	{  // 【关于】-【基础信息】
		path: 'website/about/aerta',
		name: 'm_about_aerta',
		meta: {
			title: '【中文】关于阿尔塔'
		},
		props: {languageType:1},
		component: () => import('@/pages/website/about/about_aerta')
	},{  // 【关于】-【经营资质】
		path: 'website/about/certification',
		name: 'm_certification',
		meta: {
			title: '【中文】经营资质'
		},
		props: {languageType:1},
		component: () => import('@/pages/website/about/certification_list')
	},{  // 【关于】-【企业荣誉】
		path: 'website/about/honor',
		name: 'm_honor',
		meta: {
			title: '【中文】经营资质'
		},
		props: {languageType:1},
		component: () => import('@/pages/website/about/honor_list')
	},{  // 【关于】-【新闻动态】
		path: 'website/about/news',
		name: 'm_news',
		meta: {
			title: '【中文】新闻动态'
		},
		props: {languageType:1},
		component: () => import('@/pages/website/about/news_list')
	},{  // 【关于】-【人才理念】
		path: 'website/about/recruit/brief',
		name: 'm_recruit_brief',
		meta: {
			title: '【中文】人才理念'
		},
		props: {languageType:1},
		component: () => import('@/pages/website/about/recruit_brief')
	},{  // 【关于】-【招聘岗位】
		path: 'website/about/recruit/list',
		name: 'm_recruit_list',
		meta: {
			title: '【中文】招聘岗位'
		},
		props: {languageType:1},
		component: () => import('@/pages/website/about/recruit_list')
	},{  // 【关于】-【员工福利】
		path: 'website/about/recruit/benefit',
		name: 'm_recruit_benefit',
		meta: {
			title: '【中文】员工福利'
		},
		props: {languageType:1},
		component: () => import('@/pages/website/about/recruit_benefit')
	},


	{  // 【关于】-【基础信息】
		path: 'website/about/aerta/en',
		name: 'm_about_aerta_en',
		meta: {
			title: '【中文】关于阿尔塔'
		},
		props: {languageType:2},
		component: () => import('@/pages/website/about/about_aerta')
	},{  // 【关于】-【经营资质】
		path: 'website/about/certification/en',
		name: 'm_certification_en',
		meta: {
			title: '【中文】经营资质'
		},
		props: {languageType:2},
		component: () => import('@/pages/website/about/certification_list')
	},{  // 【关于】-【企业荣誉】
		path: 'website/about/honor/en',
		name: 'm_honor_en',
		meta: {
			title: '【中文】经营资质'
		},
		props: {languageType:2},
		component: () => import('@/pages/website/about/honor_list')
	},{  // 【关于】-【新闻动态】
		path: 'website/about/news/en',
		name: 'm_news_en',
		meta: {
			title: '【中文】新闻动态'
		},
		props: {languageType:2},
		component: () => import('@/pages/website/about/news_list')
	},{  // 【关于】-【人才理念】
		path: 'website/about/recruit/brief/en',
		name: 'm_recruit_brief_en',
		meta: {
			title: '【中文】人才理念'
		},
		props: {languageType:2},
		component: () => import('@/pages/website/about/recruit_brief')
	},{  // 【关于】-【招聘岗位】
		path: 'website/about/recruit/list/en',
		name: 'm_recruit_list_en',
		meta: {
			title: '【中文】招聘岗位'
		},
		props: {languageType:2},
		component: () => import('@/pages/website/about/recruit_list')
	},{  // 【关于】-【员工福利】
		path: 'website/about/recruit/benefit/en',
		name: 'm_recruit_benefit_en',
		meta: {
			title: '【中文】员工福利'
		},
		props: {languageType:2},
		component: () => import('@/pages/website/about/recruit_benefit')
	}
];